import { filter, includes, size } from "lodash";

export interface MultiSelectDisplayOptions<T = string> {
  selectedValues: T[];
  allOptions: T[];
  labelMapper: (value: T) => string;
  includeUnassigned?: boolean;
  emptyText?: string;
  allSelectedText?: string;
  separator?: string;
}

export function getMultiSelectDisplayValue<T = string>(
  options: MultiSelectDisplayOptions<T>
): string {
  const {
    selectedValues,
    allOptions,
    labelMapper,
    includeUnassigned = false,
    emptyText = "All",
    allSelectedText = "All",
    separator = ", ",
  } = options;

  if (!selectedValues?.length) {
    return emptyText;
  }

  const hasUnassigned =
    includeUnassigned && includes(selectedValues, "-1" as T);

  const valuesWithoutUnassigned = includeUnassigned
    ? filter(selectedValues, (val) => val !== ("-1" as T))
    : selectedValues;
  const allOptionSize = includeUnassigned
    ? size(allOptions) + 1
    : size(allOptions);
  
  const allOptionsSelected = (size(selectedValues)=== allOptionSize);

  if (allOptionsSelected) {
    return allSelectedText;
  }

  const labels = valuesWithoutUnassigned.map(labelMapper);

  if (hasUnassigned) {
    labels.unshift("Unassigned");
  }

  return labels.join(separator);
}
